/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCurrencyYen = createReactComponent("outline", "currency-yen", "IconCurrencyYen", [["path", { "d": "M12 19v-7l-5 -7m10 0l-5 7", "key": "svg-0" }], ["path", { "d": "M8 17l8 0", "key": "svg-1" }], ["path", { "d": "M8 13l8 0", "key": "svg-2" }]]);

export { IconCurrencyYen as default };
//# sourceMappingURL=IconCurrencyYen.mjs.map
